import { render } from "./PerformanceChart7.vue?vue&type=template&id=8b447ccc&ts=true"
import script from "./PerformanceChart7.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart7.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__